import type { BannerId, BannerSlot, SerpBannerConfig } from '../types';
import calculateBannerSlots from './calculateBannerSlots';

interface FactoryParams {
    config: SerpBannerConfig;
    anchorWithA51: number;
    anchorWithCashback: number;
    anchorWithout: number;
    step: number;
}

interface GetterParams {
    totalCards: number;
    isEnabled: (id: BannerId) => boolean;
}

function createTourBannerSlotsGetter({ config, anchorWithA51, anchorWithCashback, anchorWithout, step }: FactoryParams) {
    return ({ totalCards, isEnabled }: GetterParams): BannerSlot[] => {
        const anchor = isEnabled('a51') ? anchorWithA51
            : isEnabled('cashback') ? anchorWithCashback
            : anchorWithout;

        return calculateBannerSlots({ config, anchor, step, totalCards, isEnabled });
    };
}

export default createTourBannerSlotsGetter;
